import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaArrowRight, FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, image, title, price, features } = plan; // Extracting data from plan

  return (
    <div className="plan-item">

      <img src={image} alt={title} />

      <div className='plan-content'>

        <div className='intro'>
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
          <h3>{title}</h3> {/* Plan Title */}
        </div>

        <div className="price">${price}</div> {/* Plan Price */}

        <div className='content'>

          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
            ))}
          </ul>

          <Button link={"Get-Quote"} title={"Get Started"} icon={FaArrowRight} />

        </div>

      </div>

    </div>
  );
};

export default Plan;